import { TableV2 } from "~/shared/ui/TableV2";
import { getCameraZoneColumns } from "~/pages/CameraZonesView/model/tableAdapter";
import Pagination from "~/components/Pagination";
import React, { memo } from "react";
import { CameraZone } from "~/schemas/generated/graphql";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface IZoneListPartProps {
  zones: CameraZone[];
  zonesTotal: number;
  loading: boolean;
}

const ZoneListPart = ({ zones, zonesTotal, loading }: IZoneListPartProps) => {
  const history = useHistory();
  const { t } = useTranslation();

  const goToZoneView = ({ id }: CameraZone) =>
    history.push(`/camera-view/${id}`);

  return (
    <Pagination total={zonesTotal}>
      {/*
      <Table
        options={CAMERA_ZONES_VIEW_OPTIONS}
        items={zones}
        sortable={false}
        loading={loading}
        type={"cameraView.table"}
        rowValuesDecorator={(item, optionName) => {
          if (optionName === "createdAt") return getFormatDate(item);
          return item;
        }}
        rowClickHandler={goToZoneView}
        rowCanBeClicked={true}
      />
      */}
      <TableV2
        columns={getCameraZoneColumns(t)}
        dataSource={zones}
        loading={loading}
        rowKey="id"
        scroll={{ x: "max-content" }}
        onRow={(record) => ({
          onClick: () => goToZoneView(record as CameraZone),
        })}
      />
    </Pagination>
  );
};

export default memo(ZoneListPart);
